import React from 'react';
import styled from '@emotion/styled';
import cognitoUtils from '../lib/cognitoUtils';

const LoginContainer = () => {
  return (
    <StyledContainer>
      <img src="icon-colo.png" alt='logo' />
      <div className="sign-in-button">
        <a className="button-link" href={cognitoUtils.getCognitoSignInUri()}>Let's Get Started!</a>
      </div>
    </StyledContainer>
  );
};

export const StyledContainer = styled.div`
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
  border-radius: 16px;
  margin-top: 100px;
  padding: 32px;

  img {
    margin: auto;
    display: flex;
  }

  .sign-in-button {
    background-color: #24b272;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    color: #fff;
    text-align: center;
    font-weight: 500;
    margin: 40px 0px 0px;
    align-items: center;
    border-width: 0;
  }

  .button-link {
    padding: 10px 20px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    font-weight: 500;
    align-self: stretch;
  }
`;

export default LoginContainer;
